import { useQuery } from '@tanstack/react-query';
import { apiFetch } from './api';
import type { BrandKit } from '../types/api';
import type { FooterDefaults } from './blocks';

/**
 * What a brand-new footer block starts with, from the brand kit: with a
 * legal notice link set, new footers link `{{ legal_notice_url }}`
 * (Terje's decision 6/10-2026). Shares the Brand kit page's query; while
 * it loads, or when it fails, new footers simply start without the link.
 */
export function useFooterDefaults(): FooterDefaults {
  const { data } = useQuery({
    queryKey: ['brand-kit'],
    queryFn: () => apiFetch<BrandKit>('/brand-kit'),
  });
  return { hasLegalNoticeUrl: Boolean(data?.legalNoticeUrl) };
}
